import { useEffect, useMemo, useState } from 'react';
import { FundraiserDetailsDto } from '../../../services/User/userService.dto';
import { userService } from '../../../services/User/userService';
import { useError } from '../../../providers/useError';

export const useFundraiserDetails = (userId?: number, userData?: FundraiserDetailsDto) => {
  const { handleError } = useError();
  const [isLoading, setIsLoading] = useState(false);
  const [user, setUser] = useState<FundraiserDetailsDto | undefined>(userData);

  const info = useMemo(() => (!!user ? `${user.firstName} ${user.lastName} (#${user.id})` : ''), [user]);

  useEffect(() => {
    if (!!user || !userId) return;
    setIsLoading(true);
    userService
      .fetchSingleFundraiser(userId)
      .then(response => setUser(response))
      .catch(error => handleError(error, error.message))
      .finally(() => setIsLoading(false));
  }, [userId, userData]);

  return { user, isLoading, info };
};
